import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider } from '@apollo/client/react'
import '@cloudscape-design/global-styles/index.css'
import { apolloClient } from '@/lib/queryClient'
import { onAuthChange } from '@/clients/firebase'
import { useAuthStore } from '@/state/authStore'
import { GET_ACCOUNT } from '@/lib/operations/account'
import type { UserAccount } from '@/lib/types'
import App from './App'

// Firebase auth listener — runs once on app start
onAuthChange(async (user) => {
  const { setUser, setAccount, setStatus, clearAuth } = useAuthStore.getState()
  if (user) {
    setUser(user)
    try {
      const { data } = await apolloClient.query<{ account: UserAccount }>({ query: GET_ACCOUNT, fetchPolicy: 'network-only' })
      const account = data?.account
      setAccount(account ?? null)
      if (account?.disabled_at) {
        setStatus('suspended')
      } else {
        setStatus('active')
      }
    } catch {
      // GET_ACCOUNT failed — could be network error or account suspended/waitlisted
      // Fall back to unauthenticated so user gets a clean retry
      clearAuth()
      void apolloClient.clearStore()
    }
  } else {
    clearAuth()
    void apolloClient.clearStore()
  }
})

const root = createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
)
